import React, { Component, Fragment } from "react";
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import {
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Input,
  Button,
  Label,
  Spinner,
  Fade,
  Alert,
} from "reactstrap";
import { connect } from "react-redux";
import {
  clear,
  updateProfile,
  updateProfileImage,
} from "../redux/actions/authActions";

export class Profile extends Component {
  state = {
    img: null,
  };
  getUser = () => {
    let user = JSON.parse(localStorage.getItem("user_info"));
    return user;
  };
  render() {
    console.log(this.props.history);
    let { auth } = this.props;
    return (
      <Fragment>
        <Header {...this.props} path={["Home", "Profile"]} />
        <Container className="profile-container mb-5">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              let obj = {
                full_name: e.target.full_name.value,
                email: e.target.email.value,
              };
              if (e.target.password.value) {
                obj.password = e.target.password.value;
              }
              this.props.updateProfile(obj);
            }}
          >
            <Row className="justify-content-between align-items-center no-gutters">
              <Col lg={6} className="p-0">
                <div
                  className="user-img"
                  style={
                    this.state.img != null
                      ? {
                          backgroundImage: `url(${URL.createObjectURL(
                            this.state.img
                          )})`,
                        }
                      : this.getUser()["profile_img"]
                      ? {
                          backgroundImage: `url(${
                            this.getUser()["profile_img"]
                          })`,
                        }
                      : {}
                  }
                >
                  <div
                    className="user-img-1 bg-dark-5"
                    style={
                      !(
                        this.state.img == null &&
                        this.getUser()["profile_img"] == null
                      )
                        ? { backgroundImage: "none" }
                        : {}
                    }
                  >
                    <label
                      for="profile-img"
                      className={`position-relative profile-upload only-pointer ${
                        this.state.img == null || auth.updateImage == -1
                          ? "d-block"
                          : "d-none"
                      }`}
                    >
                      <input
                        type="file"
                        className="d-none"
                        name="profile_img"
                        id="profile-img"
                        accept="image/*"
                        onChange={(e) => {
                          if (!e.target.files[0].type.includes("image")) {
                            alert("Only image files are allowed");
                          } else {
                            this.setState({ img: e.target.files[0] });
                          }
                        }}
                      />
                      <div className={`profile-upload-camera`}></div>
                    </label>
                  </div>
                  <div
                    className={`profile-buttons ${
                      this.state.img == null ? "" : "active"
                    }`}
                  >
                    <i
                      className="fa fa-check"
                      onClick={async (e) => {
                        await this.props.updateProfileImage(this.state.img);
                        this.setState({ img: null });
                      }}
                    ></i>
                    <i
                      className="fa fa-times"
                      onClick={(e) => {
                        this.setState({ img: null });
                      }}
                    ></i>
                  </div>
                  <div
                    className={`position-absolute loader ${
                      auth.updateImage == -1 && "active"
                    }`}
                  >
                    <Spinner />
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="user-info bg-dark-3 text-white-1 mt-5 mt-lg-0">
                  <h2>{this.getUser()["full_name"]}</h2>
                  {auth.update != -1 && (
                    <>
                      <Fade
                        in={
                          auth.update &&
                          auth.update.code &&
                          auth.update.code == 200
                        }
                        onEnter={(e) => {
                          window.setTimeout(() => {
                            this.props.clear("update");
                          }, 5000);
                        }}
                      >
                        <Alert
                          color="success"
                          isOpen={
                            auth.update &&
                            auth.update.code &&
                            auth.update.code == 200
                          }
                        >
                          You Profile has been updated successfully
                        </Alert>
                      </Fade>
                      <Fade
                        in={
                          auth.update &&
                          auth.update.code &&
                          auth.update.code != 200
                        }
                        onEnter={(e) => {
                          window.setTimeout(
                            () => this.props.clear("update"),
                            5000
                          );
                        }}
                      >
                        <Alert
                          color="danger"
                          isOpen={
                            auth.update &&
                            auth.update.code &&
                            auth.update.code != 200
                          }
                        >
                          {auth.update && auth.update.message}
                        </Alert>
                      </Fade>
                    </>
                  )}
                  <FormGroup>
                    <Input
                      type="text"
                      name="full_name"
                      placeholder="Name"
                      className="form-control mt-3"
                      required
                      defaultValue={this.getUser()["full_name"]}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="form-control mt-3"
                      required
                      defaultValue={this.getUser()["email"]}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="password"
                      name="password"
                      placeholder="••••••••"
                      className="form-control mt-3"
                      minLength={8}
                    />
                  </FormGroup>
                  {/* <FormGroup>
                                        <Label className="mt-3 px-3">Payment Method</Label>
                                        <Input type="password" placeholder="Add Your Payment Method" className="form-control mt-3" />
                                    </FormGroup> */}
                  <Button
                    block
                    type="submit"
                    disabled={auth.update && auth.update == -1}
                    className="w-100 mt-3 bg-purple-1 border-0 py-4"
                    style={{ borderRadius: 24 }}
                  >
                    {auth.update && auth.update == -1 ? (
                      <Spinner size="sm" />
                    ) : (
                      "Save Change"
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
        <Footer />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateProfile: (profileObj) => dispatch(updateProfile(profileObj)),
    updateProfileImage: (image) => dispatch(updateProfileImage(image)),
    clear: (name) => dispatch(clear(name)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
